<script lang="ts" >
import Component from 'vue-class-component'
import AdminList from '@/components/admin/AdminList.vue'
import { AloDbEnseigne } from '@/models/alodb/AloDbEnseigne'
import AdminEnseigneListLine from '@/components/admin/enseigne/AdminEnseigneListLine.vue'

@Component({
  name: 'AdminEnseigneList',
  components: {AdminEnseigneListLine}
})

export default class AdminEnseigneList extends AdminList<AloDbEnseigne> {  
 
  get itemTypeName() {
    return "Enseigne"
  }

  get componentLineName(){
    return "AdminEnseigneListLine"
  } 

}
</script>